<template>
    <div ref="exam">
        <div id="videoContainer"></div>
        <div class="userVideoBox" :class="{'close':isClose}">
            <i class="el-icon-arrow-left" :class="{'el-icon-arrow-right':!isClose}" @click="isClose=!isClose;"></i>
            <div id="userVideo"></div>
        </div>
        <el-dialog center title="确认交卷" :visible.sync="confirmVisible" width="60%">
            <p class="dialog-content null-answer">
                <span v-if="nullAnswerArr.length">你还有以下题目没有作答:{{nullAnswerArr.join(',')}}</span>
            </p>
            <p class="dialog-content null-answer">
              <span v-if="testPaper.attachFileNeeded && null == testPaper.attachFileObjectName" >你还没上传附件,请上传后再提交答卷</span>
            </p>
            <p v-if="!testPaper.attachFileNeeded || null !== testPaper.attachFileObjectName" class="dialog-content">是否确认提交答卷？</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button v-if="!testPaper.attachFileNeeded || null !== testPaper.attachFileObjectName"  type="primary" @click="toHandIn();">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog center title="交卷成功" :visible.sync="submitSuccess" width="60%" :before-close="closeExam">
            <!-- <p class="dialog-content">交卷成功，请到首页“考试记录”查看你的成绩，成绩为80%及以上，通过考试，请自行生成证书。</p> -->
            <p v-if="null == testPaper.surveyUrl" class="dialog-content">交卷成功!</p>
            <p v-if="null != testPaper.surveyUrl" class="dialog-content">交卷成功!请填写问卷</p>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="null != testPaper.surveyUrl" type="primary" @click="openSurveyUrl(testPaper.surveyUrl) && closeExam()" >填写问卷</el-button>
                <el-button v-if="null != testPaper.surveyUrl" type="primary" @click="closeExam()">不参与问卷</el-button>
                <el-button v-if="null == testPaper.surveyUrl" type="primary" @click="closeExam()">确定</el-button>
            </div>
        </el-dialog>

        <el-row class="header">
            <h3>{{testPaper.name}}</h3>
            <el-col :xs="13" :sm="13" :md="13" :lg="13" :xl="13">
                <span v-if="testPaper.questionList">已答：
                    <span class="has-answer">{{answerLength}}/{{testPaper.questionList.length}}</span>
                </span>
                <!-- 剩余15分钟的时候要弹窗提醒 -->
                <span>倒计时：
                    <span class="count-down">{{countdownStr}}</span>
                </span>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-if="testPaper.attachFileNeeded">
              <a :href=testPaper.attachFileUrl>
                <div class="handIn">
                  <el-button size="medium" type="primary">下载附件模板</el-button>
                </div>
              </a>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-if="testPaper.attachFileNeeded">
              <el-upload class="handIn"  action="/api/record/uploadFile"
                         :limit="1"
                         :data="{recordId: testPaper.id}"
                         :show-file-list="false"
                         :before-upload="beforeUpload"
                         :on-success="(response, file, fileList) => uploadAttachSuccess(response, file, fileList)"
                         :on-error="uploadAttachError"
              >
                <el-tooltip placement="bottom" :disabled="null === testPaper.attachFileOriginalName">
                  <div slot="content">已上传:{{testPaper.attachFileOriginalName}}</div>
                  <el-button size="medium" type="primary">{{null === testPaper.attachFileOriginalName? '上传附件':'重新上传'}}</el-button>
                </el-tooltip>
              </el-upload>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <div class="handIn">
                    <el-button size="medium " type="danger" @click="showHandInModle()">交 卷</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="exam-warp" v-if="currentObj">
            <div id="qid">
                <p class="title">问题&nbsp;&nbsp;#{{currentQId}}</p>
            </div>
            <div class="question-content">
                <h2>
                    <div class="mark-star">
                        <span v-if="tagArr.indexOf(currentObj.questionId)!==-1" class="el-icon-star-on"></span>
                    </div>
                    {{currentQId}}） {{currentObj.content}}
                </h2>
                <div v-if="currentObj.enContent&&isShowEn" style="width: 80%;margin:10px auto;color:#999;font-size:14px;">{{currentObj.enContent}}</div>
                <el-form ref="answer" :model="answer" class="answer-box">
                    <el-form-item v-if="currentObj.type===1">
                        <el-radio-group v-model="answer.radio">
                            <div v-for="item in currentObj.answerList" :key="item.answerId">
                                <el-radio :label="item.answerId">{{item.label}}、&nbsp;{{item.content}}&nbsp;&nbsp;
                                  <p v-if="isShowEn" class="en-content">{{item.enContent}}</p>
                                </el-radio>
                                <br>
                            </div>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="currentObj.type===2">
                        <!-- {{answer.checkbox}} -->
                        <el-checkbox-group v-model="answer.checkbox">
                            <div v-for="item in currentObj.answerList" :key="item.answerId">
                                <el-checkbox :label="item.answerId" name="type">{{item.label}}、&nbsp;{{item.content}}&nbsp;&nbsp;
                                   <p v-if="isShowEn" class="en-content">{{item.enContent}}</p>
                                </el-checkbox>
                                <br>
                            </div>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </div>
            <div class="bt-box">
                <div>
                  <el-button size="small" type="primary" @click="switchQ(currentQId-2)" :class="{'disable-bt':!firstVisibleBt}">上一题</el-button>
<!--                  <el-button size="small" type="primary" @click="isShowEn=!isShowEn" >-->
<!--                    <span v-if="!isShowEn">显示英文</span>-->
<!--                    <span v-if="isShowEn">隐藏英文</span>-->
<!--                  </el-button>-->
                <el-button size="small" type="warning" @click="marking()" v-if="tagArr.indexOf(currentObj.questionId)==-1">标记此题</el-button>
                <el-button size="small" type="warning" @click="marking()" v-if="tagArr.indexOf(currentObj.questionId)!=-1">取消标记</el-button>
                <el-button size="small" type="primary" @click="switchQ(currentQId)" :class="{'disable-bt':!lastVisibleBt}">下一题</el-button>

                </div>
            </div>
            <div class="footer">
                <span v-for="(item,index) in testPaper.questionList" :key="item.questionId" @click="switchQ(index)">
                    <el-button size="small" type="warning" v-if="tagArr.indexOf(item.questionId)!==-1">{{index+1}}</el-button>
                    <el-button size="small" v-else-if="!answerObj[item.questionId]">{{index+1}}</el-button>
                    <el-button size="small" type="success" v-else>{{index+1}}</el-button>
                </span>
            </div>
        </div>
<!--        </div>-->
    </div>
</template>

<script>
import { AliRTSPusher} from 'aliyun-rts-pusher';
import Client from 'ali-oss';

var recordId;
export default {
  data: function() {
    return {
        initialized:false,
        isDebugCamera:true,
      isClose: false,
      submitSuccess: false,
      isShowEn: false,
      confirmVisible: false,
      uploadAttach: false,
      enableCamera: true,
      lastVisibleBt: true,
      firstVisibleBt: false,
      nullAnswerArr: [],
      answerObj: {},
      tagArr: [],
      countdownValue: 0,
      countdownStr: "0:00:00",
      answerLength: 0,
      countdown: {},
      answer: {
        radio: {},
        checkbox: []
      },
      testPaper: {
        subjectId: this.$route.query.id,
        attachFileNeeded: false,
        attachFileUrl:'',
        attachFileObjectName:null,
        attachFileOriginalName:null,
          surveyUrl: null,
          subjectName: null,
      },
      currentQId: 1,
      currentObj: {},
      mediaStreamTrack: null,
        pushClient:null,

    };
  },
  computed: {
    userInfo: function() {
      return this.$store.state.userInfo;
    }
  },

  //生命周期钩子，dom树挂载上去之后执行
  async mounted() {
    let subjectId = this.$route.query.id;
    //禁用复制粘贴 、 右键菜单
    let allowedCopyRes = await this.$axios.get(`/subject/allowedCopy/${subjectId}`);
    if (allowedCopyRes.code !== 200 || allowedCopyRes.data === false) {
      this.$refs.exam.oncopy = this.$refs.exam.oncut = () => {
        return false;
      };
      this.$refs.exam.oncontextmenu = this.$refs.exam.ondragstart = this.$refs.exam.onselectstart = this.$refs.exam.onbeforecopy = () => {
        return false;
      };
    }

    this.envInit();
  },

  // 生命周期钩子，当前组件销毁前执行
  beforeDestroy() {
    //如果尚未交卷，先暂存答案(以testPaper.id判断是否已经获得试题)
    !this.submitSuccess && this.testPaper.id && this.$axios.post("/record/saveAnswer", this.creatAnswer());
    //不再监听离开事件
    // window.onblur = null;
    window.onblur = null;
    //关闭摄像头
    // this.mediaStreamTrack && this.mediaStreamTrack.getTracks()[0].stop();
    if(this.pushClient) {
        this.pushClient.stopPush();
        this.pushClient.stopScreenCapture();
        this.pushClient.stopCamera();
        this.pushClient.stopMicrophone();
        this.pushClient.dispose();
        this.pushClient =null;
    }
    this.clear();
  },
  methods: {
      async envInit() {
          const loading = this.$loading({
              lock: true,
              text: "环境准备中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
          });

          //这里先判断是否需要开启摄像头,如果不需要，直接往下走
          let enableCameraRes = await this.$axios.get(
              "/systemConfig/getEnableCamera"
          );

          // 如果不需要监控，直接初始化
          if (!enableCameraRes.data) {
              this.enableCamera = false;
              loading.close();
              this.init();
              return;
          }

          let subjectId = this.$route.query.id;
          // 获取当前考试的监控视频上传url
          let authUrlRes = await this.$axios.get(`/record/monitorUrl?subjectId=${subjectId}`);
          if (authUrlRes.code !== 200) {
              loading.close();
              this.$router.replace("/home");
          }
          this.pushClient = AliRTSPusher.createClient();
          const userVideo = this.pushClient.setRenderView('userVideo'); // 静音自动播放
          userVideo.controls=false;
          userVideo.muted =true;
          this.pushClient.setVideoQuality("1080p_2");
          this.pushClient.on('error',error => {
              let message = error.errorCode === 10012?
                  "由于您退出屏幕共享功能，系统已自动退出考试页面！请重新进入考试，并确保开启桌面共享功能后继续考试。":`监控遇到错误[${error.errorCode}_${error.message}],系统已自动退出考试页面！`;
              this.$confirm(message, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
              });
              this.$router.replace("/home");
              loading.close();
          });
          this.pushClient.on('connectStatusChange',event => {
              switch (event.status) {
                  case 1:
                      // 连接中
                      console.log("connectStatusChange",1)
                      break;
                  case 2:
                      // 已连接
                      console.log("connectStatusChange",2)
                      console.log("监控连接成功");
                      this.$notify({
                          title: '监控连接',
                          message: '监控连接成功！',
                          type: 'success'
                      });
                      loading.close();
                      if (!this.initialized) {
                          this.initialized=true;
                          this.init();
                      }
                      break;
                  case 3:
                      // 自动重连中，注意此时推流已暂时中断，应及时提示用户
                      console.log("connectStatusChange",3)
                      break;
                  case 0:
                      // 连接中断，推流结束，应提示用户，必要时重新调用 startPush 进行推流
                      console.log("connectStatusChange",0)
                      this.$confirm(`监控连接中断，自动退出考试页面`, '提示', {
                          confirmButtonText: '确定',
                          showCancelButton: false,
                          showClose: false,
                          type: 'warning'
                      });
                      break;
              }
          });
          const videoEffectManager = this.pushClient.getVideoEffectManager();
          videoEffectManager.enableMixing(true);
          videoEffectManager.setMixingConfig({
              videoWidth: 1920,
              videoHeight: 1080,
              videoFramerate: 30
          })
          let cl = await AliRTSPusher.createClient().getDeviceManager().getCameraList();
          cl = cl.filter(mediaDeviceInfo => mediaDeviceInfo.label.indexOf('OBS')<0 && mediaDeviceInfo.label.indexOf('Virtual') <0)
          const cameraStreamId = await this.pushClient.startCamera(cl[0].deviceId).catch(error => {
              this.$confirm(`监控摄像头连接失败[${JSON.stringify(error)}}]，自动退出考试页面，`, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
              });
              this.$router.replace("/home");
              loading.close();
          });
          const screenStreamId = await this.pushClient.startScreenCapture().catch(error => {
              this.$confirm(`监控录屏连接失败[${JSON.stringify(error)}}]，自动退出考试页面，`, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
              });
              this.$router.replace("/home");
              loading.close();
          });
          const micStreamId = await this.pushClient.startMicrophone().catch(error => {
              this.$confirm(`监控麦克风连接失败[${JSON.stringify(error)}}]，自动退出考试页面，`, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
              });
              this.$router.replace("/home");
              loading.close();
          });
          if (!cameraStreamId || !screenStreamId || !micStreamId) {
            console.log("获取摄像头、屏幕、麦克风失败")
            return;
          }
          videoEffectManager.setLayout([
              { streamId: screenStreamId, x: 1920/2, y: 1080/2, width: 1920, height: 1080, zOrder: 1 },
              { streamId: cameraStreamId, x: 320/2, y: 180/2, width: 320, height: 180, zOrder: 2 },
          ]);

          const track = this.pushClient.getSourceStream(cameraStreamId).getVideoTracks()[0];
          this.imageCapture = new ImageCapture(track);
          this.pushClient.startPush(authUrlRes.data);
      },
    async capture() {
        if (null == this.testPaper || null == this.testPaper.id) {
            return;
        }
        this.imageCapture.takePhoto().then(blob => {
            const formData = new FormData;
            formData.set("recordId",this.testPaper.id);
            formData.set("file",blob,"capture.jpg");
            this.$axios.post("/record/uploadImageCapture",formData)
        }).catch(error=>{
            // do nothing
        });
    },
    async init() {
        let subjectId = this.$route.query.id;
        let res = await this.$axios.get("/record/existsOnTheExamRecord");
        if (res.code !== 200) {
            loading.close();
            this.$message.error(res.errMsg);
            return;
        }

        let getQuestionRes = null;
        if (res.data) {
            getQuestionRes = await this.$axios.get("/record/reload", {
                params: { subjectId: subjectId }
            });
        } else {
            getQuestionRes = await this.$axios.get("/record/takeExam", {
                params: { subjectId: subjectId }
            });
        }

        if (getQuestionRes && getQuestionRes.code === 200) {
            this.getQuestionsCallBack(getQuestionRes);
        } else {
            //抽题或者重新加载试题失败，回到登陆后的首页
            this.$message.error(getQuestionRes.errMsg);
            this.$router.replace("/home");
        }

        // window.onmouseleave
        window.onblur = this.leave;
      this.answerObjLength();

      let storeData = localStorage.getItem(
        `user${this.userInfo.id}subject${this.testPaper.subjectId}tagArr`
      );
      this.tagArr = storeData ? JSON.parse(storeData) : [];

      // 两分钟保存一下答案
      console.debug("设置定时暂存答案");
      this.saveAnswerCountdown = setInterval(() => {
        console.debug("定时器工作中");
        this.saveAnswer();
      }, 120000);
      // 15分钟截图一次
        this.imageCaptureInterval = setInterval(() => {
            this.capture();
        },1000*60*5);
    },

    clear() {
      console.debug("clear start");
      localStorage.removeItem(
        `user${this.userInfo.id}subject${this.testPaper.subjectId}answer`
      );
      localStorage.removeItem(
        `user${this.userInfo.id}subject${this.testPaper.subjectId}tagArr`
      );
      window.clearInterval(this.countdown);
      window.clearInterval(this.saveAnswerCountdown);
      window.clearInterval(this.imageCaptureInterval);
      console.debug("clear end")
    },

    exitFullscreen() {
      if (null === document.fullscreenElement) {
        return;
      }
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    showHandInModle() {
      this.confirmVisible = true;
      this.nullAnswerArr = [];
      this.testPaper.questionList.forEach((question, index) => {
        if (!this.answerObj[question.questionId]) {
          this.nullAnswerArr.push(index + 1);
        }
      });
    },
    creatAnswer() {
      let answerIdList = [];
      for (const key in this.answerObj) {
        if (this.answerObj.hasOwnProperty(key)) {
          if (this.answerObj[key] != undefined) {
            if (typeof this.answerObj[key] === "number") {
              if (this.answerObj[key] != null)
                answerIdList.push(this.answerObj[key]);
            } else {
              for (const answerItem of this.answerObj[key]) {
                if (answerItem != null) answerIdList.push(answerItem);
              }
            }
          }
        }
      }
      let answerObj = {
        userId: this.userInfo.id,
        answerIdList: answerIdList,
        recordId: this.testPaper.id
      };
      return answerObj;
    },

    downloadAttachFileTemplate() {
      let url = window.location.host+this.testPaper.attachFileUrl;
      window.open(encodeURI(url));
    },
    beforeUpload(file) {
      const isDox = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      if (!isDox) {
        this.$message.error("只能上传docx文件!");
        return false;
      }
      console.log(file.size / 1024 / 1024 > 20)
      if (file.size / 1024 / 1024 > 20) {
        this.$message.error("上传文件大小不得超过20MB!");
        return false;
      }
      return true;
    },
    uploadAttachSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.errMsg);
        return;
      } else {
        console.log(res)
        this.testPaper.attachFileOriginalName = res.data.attachFileOriginalName;
        this.testPaper.attachFileObjectName = res.data.attachFileObjectName;
        this.$message.success(`上传附件(${res.data.attachFileOriginalName})成功！`);
      }
    },
    uploadAttachError(err, file, fileList) {
      this.$message.error("上传文件失败！");
    },
    async toHandIn() {
      let res = await this.$axios.post(
        "/record/saveAnswer",
        this.creatAnswer()
      );
      if (res.code === 200) {
        let res_ = await this.$axios.get("/record/finishExam", {
          params: {
            recordId: this.testPaper.id
          }
        });
        if (res_.code === 200) {
          this.submitSuccess = true;
          this.confirmVisible = false;
          this.clear();

        }
      }
    },
    async handIn_() {
      window.clearInterval(this.countdown);
      let res = await this.$axios.post(
        "/record/saveAnswer",
        this.creatAnswer()
      );
      if (res.code === 200) {
        let res_ = await this.$axios.get("/record/finishExam", {
          params: {
            recordId: this.testPaper.id
          }
        });
        if (res_.code === 200) {
          this.$message({
            message: "已到交卷时间，系统已经自动交卷！",
            type: "warning"
          });
          this.clear(); //TODO 真的需要么，路由变化会触发beforeDestory方法，会自动清除吧？
          this.$router.replace("/home");
        }
      }
    },

    answerObjLength() {
      this.answerLength = 0;
      for (let key in this.answerObj) {
        if (
          this.answerObj.hasOwnProperty(key) &&
          this.answerObj[key] !== undefined
        ) {
          this.answerLength++;
        }
      }
    },

    marking() {
      if (this.tagArr.indexOf(this.currentObj.questionId) == -1) {
        this.tagArr.push(this.currentObj.questionId);
      } else {
        this.tagArr = this.tagArr.filter(t => t != this.currentObj.questionId);
      }
      localStorage.setItem(
        `user${this.userInfo.id}subject${this.testPaper.subjectId}tagArr`,
        JSON.stringify(this.tagArr)
      );
    },

    answerObjNewAttr(key, newValue) {
      this.answerObj[key] = newValue;
      this.answerObjLength();
      localStorage.setItem(
        `user${this.userInfo.id}subject${this.testPaper.subjectId}answer`,
        JSON.stringify(this.answerObj)
      );
    },

    closeExam() {
      this.$router.replace("/home");
    },

      openSurveyUrl(surveyUrl) {
          console.log(surveyUrl);
          window.open(surveyUrl);
      },

    switchQ(index) {
      this.firstVisibleBt = index > 0;
      this.lastVisibleBt = index < this.testPaper.questionList.length - 1;
      if (!this.testPaper.questionList[index]) {
        return;
      }

      this.answer = {
        radio: "",
        checkbox: []
      };
      this.currentObj = this.testPaper.questionList[index];
      this.currentQId = index + 1;

      if (!this.answerObj[this.currentObj.questionId]) {
        return;
      }
      if (this.currentObj.type == 1) {
        this.answer.radio = this.answerObj[this.currentObj.questionId];
      } else if (this.currentObj.type == 2) {
        this.answer.checkbox = this.answerObj[this.currentObj.questionId];
      }
    },

    open() {
      const h = this.$createElement;
      this.$notify({
        title: "考试时间提醒",
        message: h(
          "i",
          { style: "color: #e83737" },
          "还剩余15分钟，抓紧时间答卷哦"
        ),
        offset: 100,
        type: "warning"
      });
    },

    saveAnswer() {
      return this.$axios.post("/record/saveAnswer", this.creatAnswer());
    },

    formatSeconds(result) {
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      return (result = h + ":" + m + ":" + s);
    },
    getQuestionsCallBack(res) {
      this.testPaper = res.data;
      recordId = this.testPaper.id;
      this.testPaper.surveyUrl = this.testPaper.subject.surveyUrl;
      this.testPaper.subjectName = this.testPaper.subject.name;
      this.currentObj = this.testPaper.questionList[0];
      this.countdownValue =
        parseInt(res.data.countDown) > 0
          ? parseInt(res.data.countDown)
          : -parseInt(res.data.countDown);

      if (this.currentObj.type == 1) {
        this.answer.radio = this.answerObj[this.currentObj.questionId];
      } else if (this.currentObj.type == 2) {
        this.answer.checkbox = this.answerObj[this.currentObj.questionId];
      }

      let start = new Date();
      this.countdown = setInterval(() => {
        let now = new Date();
        let diff = parseInt((now.getTime() - start.getTime()) / 1000); //秒
        let c = this.countdownValue - diff;
        if (c > 0) {
          this.countdownStr = this.formatSeconds(c);
        } else {
          this.handIn_();
        }
        if (c == 15 * 60) {
          this.open();
        }
      }, 1000);

      // create answerObj
      this.testPaper.questionList.forEach(question => {
        let answerArr = [];

        question.answerList.forEach(answer => {
          if (answer.userFlag) {
            answerArr.push(answer.answerId);
          }
        });
        if (answerArr.length > 0) {
          if (question.type === 1) {
            this.answerObjNewAttr(question.questionId, answerArr[0]);
          } else {
            this.answerObjNewAttr(question.questionId, answerArr);
          }
        }
      });
      this.switchQ(0);
    },

    //离开当前窗口时调用
    async leave() {
      let res = await this.$axios.get("/record/switch", {
        params: { recordId: this.testPaper.id }
      });
      if (res.code != 200) {
        this.$message.error(res.errMsg);
        return;
      }
      let data = res.data;
      if (data.switchLimit >= 0 && data.currentCount >= data.switchLimit) {
        this.$alert(
            `您累计切换考试页面已超过${data.switchLimit-1}次，系统已自动提交答卷`,
            "警告",
            {
              type: "warning",
              callback: action => {
                this.$router.replace("/home");
              }
            }
        );

      } else if (data.switchLimit >=0) {         // switchLimit 科目设置强制交卷的切换次数
          let message = "切换考试页面将导致系统自动交卷。请专心完成考试，避免不良记录。"
          // if (data.currentCount === data.switchLimit-1) {
          //     message = `您已经切换了${data.currentCount}次页面，再次切屏将导致系统自动提交您目前的答卷，无法再进行任何答题操作，请谨慎操作！`
          // } else
          if (data.currentCount > 1){
              message = `您已经切换了${data.currentCount}次页面，若切换考试页面超过${data.switchLimit-1}将导致系统自动交卷，请谨慎操作！`
          }
          this.$alert(message, "注意", { type: "warning" });
      } else if  (data.enableSwitchCount && data.maxSwitchCount <= data.currentCount) {
        // enableSwitchCount全局设置，是否开启切换限制
        // maxSwitchCount全局设置，超过多次开始弹出告警
        this.$alert(`切换考试页面将导致系统自动交卷。请专心完成考试，避免不良记录。`, "注意", { type: "warning" });
      }
    }
  },

  watch: {
    "answer.radio": function(newValue) {
      if (newValue !== "") {
        this.answerObjNewAttr(this.currentObj.questionId, newValue);
      }
    },
    "answer.checkbox": function(newValue) {
      if (newValue.length) {
        this.answerObjNewAttr(this.currentObj.questionId, newValue);
      }
    }
  }
};
</script>

<style scoped>
.en-content{
  font-size: 13px;
  color: #999;
}
.disable-bt {
  opacity: 0;
  cursor: initial;
}
.en-show-bt {
  display: inline;
  font-size: 0;
  margin-right: 14px;
  cursor: pointer;
}
.en-show-bt span {
  font-size: 14px;
}
.disable-bt {
  opacity: 0;
  cursor: initial;
}
.userVideoBox {
  position: fixed;
  right: 0;
  z-index: 5;
  transition: 0.3s all linear;
}
.userVideoBox.close {
  right: -300px;
}
.userVideoBox .el-icon-arrow-left,
.userVideoBox .el-icon-arrow-right {
  position: absolute;
  top: 50%;
  margin-top: -13px;
  cursor: pointer;
  color: #fff;
  font-size: 27px;
}
#userVideo {
  width: 300px;
  /* border-top-left-radius: 10px;
  border-bottom-left-radius: 10px; */
  border: 4px solid rgba(0, 0, 0, 0.8);
  border-left-width: 25px;
  border-right-width: 0;
  box-shadow: -2px 2px 5px 3px rgba(7, 17, 27, 0.3);

  border-right-width: 0;
}

.null-answer {
  display: block;
  word-break: break-all;
  word-wrap: break-word;
}
.mark-star {
  width: 10px;
  display: inline-block;
}
.question-content {
  min-height: 300px;
}
.has-answer {
  color: #999;
  margin-right: 20px;
}
.el-icon-star-on {
  color: #e83737;
  font-size: 12px;
}
.count-down {
  color: #e83737;
  font-size: 30px;
}
.header {
  line-height: 30px;
  margin-bottom: 10px;
  max-width: 1000px;
  margin: 20px auto 10px auto;
}
.handIn {
  text-align: right;
}
.footer {
  text-align: center;
  background: #2151a2;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 10px 0;
}
.el-radio-group .el-radio {
  height: 40px;
  line-height: 40px;
}
.el-form-item {
  margin: 0;
}
.footer .el-button {
  margin: 5px;
  font-size: 16px;
  padding: 5px 8px;
  border-radius: 0;
}
.bt-box {
  text-align: center;
  padding: 10px 0 30px 0;
}
.answer-box {
  width: 80%;
  margin: 20px auto 0 auto;
  border: 1px solid #747474;
  border-radius: 8px;
  padding: 10px 20px;
}
h2 {
  background: #777;
  color: #fff;
  width: 80%;
  font-size: 16px;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 400;
  margin: auto;
  margin-top: 30px;
  line-height: 26px;
}
#qid {
  height: 40px;
  padding: 8px 10px 0 10px;
  color: #fff;
  background: #2151a2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
#qid .title {
  background: #004078;
  height: 30px;
  margin: auto;
  text-indent: 0.5em;
  border-radius: 4px;
  line-height: 30px;
}
.exam-warp {
  position: relative;
  border: 1px solid #747474;
  border-radius: 10px;
  width: 1000px;
  margin: 0 auto;
}
.switch-icon {
  font-weight: 800;
  display: inline-block;
  color: #fff;
  background: #2151a2;
  border-radius: 50%;
  padding: 4px;
  font-size: 30px;
  position: fixed;
  left: 50px;
  top: 50%;
  margin-top: -19px;
  cursor: pointer;
}
.switch-icon:last-child {
  left: auto;
  right: 50px;
}
@media screen and (max-width: 1000px) {
  .bt-box {
    padding: 8px 0 20px 0;
  }
  h2 {
    font-size: 14px;
    line-height: 22px;
    margin-top: 10px;
    border-radius: 4px;
  }
  .exam-warp {
    width: auto;
    border-radius: 0;
  }
  .count-down {
    font-size: 18px;
  }
  .has-answer {
    font-size: 12px;
  }
  #qid,
  .footer,
  #qid .titles {
    border-radius: 0;
  }
  .header {
    padding: 10px;
    margin: 0;
  }
}
</style>
